import { utagLinkCart, utagLinkChat } from 'features/tealium';
import { openMessenger } from 'features/genesysCloud';
import { setGenericEvent } from 'features/tealium/ga4/custom';

import addHeaderSecureMessage from '../addHeaderSecureMessage';
import { startAvailabilityCheck, stopAvailabilityCheck } from '../../availabilityCheck';
import togglePageLoadingIndicator from '../../togglePageLoadingIndicator';
import handleCartRequestResponse from '../../api/handleCartRequestResponse';
import { registerAvailabilityCheck, GetCurrentCartOverview, GetHoldReasons } from '../../api';
import { cart, cartModel, overview } from '../config';
import dynamicImport from '../../../../features/webpack/dynamicImport.macro';

import OverviewEmptyLayout from './OverviewEmptyLayout';
import OverviewLayout from './OverviewLayout';

overview.app = new Backbone.Marionette.Application({});
const { app } = overview;
const trackCartEvents = utagLinkCart();
const trackChatEvents = utagLinkChat();

registerAvailabilityCheck(
	() => startAvailabilityCheck(cartModel),
	() => stopAvailabilityCheck
);

app.on('start', function () {

	// Only show the secure message for employees
	if (window.lp.globals.isCustomerService || window.lp.globals.isKiosk) {

		addHeaderSecureMessage();

	}

	// API Requests Loading Indicator
	const loadingIndicator = new lp.LoadingIndicator();
	loadingIndicator.initialize();

	// Listen for requests
	$(cart).on('indicateLoad', (e, deferred) => {

		loadingIndicator.pushDeferred(e, deferred);

	});

	// Listen to removal of product items for last item removed: show empty state
	this.listenTo(
		cartModel,
		'change:ProductItems',
		function () {

			const productItemsCount = cartModel.get('ProductItems').length;
			const previousProductItems = cartModel.previousAttributes().ProductItems || [];
			const previousProductItemsCount = previousProductItems.length;

			if (previousProductItemsCount !== productItemsCount) {

				if (productItemsCount < 1) {

					this.showEmptyCart(false);

				} else {

					this.showPopulatedCart();

				}

			}

		},
		this
	);

	if (window.lp.globals.isCustomerService) {

		// Rename CSR Cart
		dynamicImport('desktop/cart/overview-CSRCartNameView', './CSRCartNameView').then((module) => {

			const CSRCartNameView = module.default;
			app.CSRCartNameView = new CSRCartNameView();

		});

	}

});

app.showEmptyCart = function (pageLoad) {

	// Hide the Cart Interface, Show the Cart Empty container
	$('#cartInterface, #cartId, .shopWithConfidence').addClass('hidden');
	$('#cartEmpty').removeClass('hidden');

	trackCartEvents({
		eventAction: 'Empty-Cart',
		nonInteraction: pageLoad ? 1 : 0
	});

};

app.showPopulatedCart = function () {

	// Show the Cart Interface, Hide the Cart Empty container
	$('#cartInterface, #cartId, .shopWithConfidence').removeClass('hidden loading');
	$('#cartEmpty').addClass('hidden');
	$('#cartId').html(`Cart #${cartModel.get('Id')}`);

};

// Prepare initial request, use page's initial JSON if available
let initialRequest;
const initialSuccess = function (response) {

	cartModel.update(response);
	app.start();

	if (cartModel.get('ProductItems').length > 0) {

		app.showPopulatedCart();

	} else {

		app.showEmptyCart(true);

	}

};
const initialFailure = function () {

	app.start();
	app.showEmptyCart(true);

};

function initialize () {

	let csrRequests;

	togglePageLoadingIndicator(true, true);

	if (lp.cart.initialJSON) {

		// use page's initial JSON
		initialRequest = handleCartRequestResponse(
			Promise.resolve().then(() => lp.cart.initialJSON),
			startAvailabilityCheck
		).then((response) => initialSuccess(response));

	} else {

		initialRequest = GetCurrentCartOverview()
			.then((response) => initialSuccess(response))
			.catch(() => initialFailure());

	}

	initialRequest.finally(() => {

		app.emptyLayout = new OverviewEmptyLayout({
			el: '#cartEmpty',
			model: cartModel
		});
		app.emptyLayout.render();

		app.layout = new OverviewLayout({
			el: '#cartInterface',
			model: cartModel
		});
		app.layout.render();

		if (window.lp.globals.isCustomerService) {

			let CSRPanelView;
			const importCSRPanelView = dynamicImport('desktop/cart/overview-CSRPanelView', './CSRPanelView').then(
				(module) => {

					CSRPanelView = module.default;

				}
			);

			let ImportCartView;
			const importImportCartView = dynamicImport('desktop/cart/overview-ImportCartView', './ImportCartView').then(
				(module) => {

					ImportCartView = module.default;

				}
			);

			let holdReasons;
			const getHoldReasons = GetHoldReasons().then((response) => {

				holdReasons = response;

			});

			csrRequests = Promise.all([ getHoldReasons, importCSRPanelView, importImportCartView ])
				.then(() => {

					const csrPanel = new CSRPanelView({
						model: cartModel,
						holdReasons
					});
					csrPanel.render();
					app.importCartView = new ImportCartView();

				})
				.finally(() => togglePageLoadingIndicator(false));

		} else {

			// Add a delay as rendering PayPal Later widget on Safari somehow interferes with "loading" class removal
			setTimeout(() => {

				togglePageLoadingIndicator(false);

			}, 100);

		}

		if (!window.lp.globals.isCustomerService && !window.lp.globals.isEmployeeConnectedAsCustomer) {

			startAvailabilityCheck(cartModel);

		}

		const chatButtonsList = document.querySelectorAll('.needHelp .chatWrapperWithIcon button');
		chatButtonsList.forEach((button) => {

			if (!button.className.includes('proContactOption')) {

				button.addEventListener('click', (el) => {

					openMessenger();
					trackChatEvents({
						eventAction: 'Request-Chat',
						eventLabel: 'Cart'
					});

					setGenericEvent({
						event_name: 'chat_click',
						chat_button_type: 'static',
						chat_button_text: el.target.innerHTML
					});

				});

			}

		});

	});

	return Promise.all([ initialRequest, csrRequests ]);

}

export default initialize;
